"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.THUMBNAIL_SPACING_VALUE_PER_PRESET = exports.THUMBNAIL_SPACING_PRESETS = void 0;
var THUMBNAIL_SPACING_PRESETS;
(function (THUMBNAIL_SPACING_PRESETS) {
    THUMBNAIL_SPACING_PRESETS["NONE"] = "NONE";
    THUMBNAIL_SPACING_PRESETS["NARROW"] = "NARROW";
    THUMBNAIL_SPACING_PRESETS["WIDE"] = "WIDE";
})(THUMBNAIL_SPACING_PRESETS = exports.THUMBNAIL_SPACING_PRESETS || (exports.THUMBNAIL_SPACING_PRESETS = {}));
exports.THUMBNAIL_SPACING_VALUE_PER_PRESET = (_a = {},
    _a[THUMBNAIL_SPACING_PRESETS.NONE] = 0,
    _a[THUMBNAIL_SPACING_PRESETS.NARROW] = 24,
    _a[THUMBNAIL_SPACING_PRESETS.WIDE] = 52,
    _a);
//# sourceMappingURL=thumbnail-spacing-presets.js.map